<template>
  <div class="card floating">
    <div class="card-content">
      <p v-if="isSharedDrive">{{ $t('prompts.exitSharedDrive') }}</p>
      <p v-else-if="req.kind !== 'listing'">{{ $t('prompts.deleteMessageSingle') }}</p>
      <p v-else>{{ $t('prompts.deleteMessageMultiple', { count: selectedCount}) }}</p>
    </div>
    <div class="card-action">
      <button @click="$store.commit('closeHovers')" id ="buttonCancelDelete"
        class="button button--flat button--grey"
        :aria-label="$t('buttons.cancel')"
        :title="$t('buttons.cancel')">{{ $t('buttons.cancel') }}</button>
      <button @click="submit"
        class="button button--flat button--red" id ="buttonDelete"
        :aria-label="$t('buttons.delete')"
        :title="$t('buttons.delete')">{{ $t('buttons.delete') }}</button>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import { files as api } from '@/api';
import { ROUTES } from '@/router';

export default {
  name: 'delete',
  mounted () {
    this.setIsPrompt(true);
    this.setIsRename(true);
  },
  computed: {
    ...mapGetters(['isListing', 'selectedCount', 'isSharedDrive', 'isLogged']),
    ...mapState(['req', 'selected', 'isRename', 'handleRecord', 'linkSharedDrive']),
    isSharedDrive() {
      if (this.req.items[this.selected[0]].type === Module.NodeType.SHARED_DRIVE_ROOT.value && this.$route.name === ROUTES.SHARED_WITH_ME) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations(['closeHovers', 'setIsPrompt', 'setIsRename', 'setParentHandle']),
    submit: async function () {
      document.getElementById('buttonDelete').disabled = true;
      document.getElementById('buttonCancelDelete').disabled = true;
      try {
        if (this.handleRecord !== null) {
          await api.removeId(this.handleRecord);
          this.closeHovers();
          this.$store.commit('setReload', true);
          return;
        }

        if (this.isSharedDrive) {
          for (let index of this.selected) {
            if (this.req[index] && (this.req[index].type === Module.NodeType.SHARED_DRIVE_ROOT.value)) {
              this.deleteNestedDrives(this.req[index].handle);
            } else if (this.req.items[index].type === Module.NodeType.SHARED_DRIVE_ROOT.value) {
              this.deleteNestedDrives(this.req.items[index].handle);
            } else {
              const {nodeList} = await ibb.getSortedChildren(this.req.handle, -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
              for (let item of nodeList) {
                if (item.name === this.req.items[index].name) {
                  await api.removeId(item.handle);
                }
              }
            }
          }
          this.closeHovers();
          return;
        }

        if ((!this.isListing && this.$route.name !== ROUTES.DRIVE) || this.selected.length === 0) {
          if (this.$route.name === ROUTES.DRIVE) {
            await api.removeId(this.req.handle, ibbLink);
            let parentNode = await ibbLink.getNodeById(this.req.parentHandle);
            if (parentNode.node.parentHandle === '') {
              this.$router.push({ path: this.$route.path + '#' + this.linkSharedDrive });
            } else {
              this.$router.push({ path: this.$route.path + '#' + this.req.parentHandle });
            }
          } else {
            await api.removeId(this.req.handle);
            this.$router.push({ path: this.$route.path + '#' + this.req.parentHandle });
          }
          this.closeHovers();
          return;
        }

        if (this.selectedCount === 0) {
          return;
        }

        let promises = [];
        if (!this.isLogged || (this.isLogged && this.$route.name === ROUTES.DRIVE)) {
          for (let index of this.selected) {
            const {nodeList} = await ibbLink.getSortedChildren(this.req.handle, -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
            for (let item of nodeList) {
              if (item.name === this.req.items[index].name) {
                promises.push(api.removeId(item.handle, ibbLink));
              }
            }
            this.setParentHandle(null);
          }
        } else {
          for (let index of this.selected) {
            const {nodeList} = await ibb.getSortedChildren(this.req.handle, -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value);
            for (let item of nodeList) {
              if (item.name === this.req.items[index].name) {
                promises.push(api.removeId(item.handle));
              }
            }
            this.setParentHandle(null);
          }
        }
        
        await Promise.all(promises);
        this.closeHovers();
        this.$store.commit('setReload', true);
        this.$store.commit('resetSelected');
      } catch (e) {
        this.closeHovers();
        this.$showError(e);
        if (this.isListing) this.$store.commit('setReload', true);
      }
    },
    async deleteNestedDrives (handle) {
      let nestedShares = await ibb.getSharedDrives();
      nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === handle);
      for (let sharedDrive of nestedShares) {
        this.deleteNestedDrives(sharedDrive.handle);
      }
      await ibb.deleteSharedDrive(handle);
    }
  },
  beforeDestroy () {
    this.setIsPrompt(false);
    this.setIsRename(false);
  }
};
</script>